module.exports = __webpack_public_path__ + "static/img/noDataye.75cdc9c5.png";